export default __webpack_public_path__ + "8e6ae03177876a71877619f2ed91f2ca.png";